import { useEffect, useState } from 'react'
import { useRequest, useView } from '@10000/react'
import { createHash } from '@10000/react/src/deviceHash'
import { randomInt } from '@10000/common'
import { InputScreen, useBackground, useShell, useStack } from '../../layout'
import { H3 } from '../../widgets'
import { Avatar, Text } from '../../forms'
import { Splash } from '.'

const load = () => ({
  avatar: +(window.localStorage['SELECTED_AVATAR'] ?? randomInt(6)),
  name: window.localStorage['SELECTED_NAME'] ?? ''
})
const save = ({ avatar, name }) => {
  window.localStorage['SELECTED_AVATAR'] = avatar
  window.localStorage['SELECTED_NAME'] = name
}

export const Profile = ({ active }) => {
  const request = useRequest('squiz')
  const { push } = useStack()
  const { options: { solo } = {} } = useView('squiz')
  const [visible, setVisible] = useState(false)

  useShell({ active, mode: 'logo' })
  useBackground().set({ active, background: 1, position: '50% 5%', size: '400%', fade: true })

  useEffect(() => {
    createHash()
      .then(hash => request('rejoinRequested', { hash }))
      .finally(() => setVisible(true)) // only show the UI when the rejoinRequested event has been processed
  }, [request])

  const join = async (details) => {
    save(details)
    return request('participantJoined', { ...details, hash: await createHash() })
  }
  const showSplash = (values) => push(Splash, { props: values })

  return visible && (
    <InputScreen onSubmit={solo ? showSplash : join} formValues={load()} footerButton={solo ? 'Start Squiz' : 'Join team'}>
      <H3 align="center">Create your profile</H3>
      <Avatar name="avatar" size="large" />
      <Text name="name" title="Name" required />
    </InputScreen>
  )
}